import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Inter vem empacotada localmente: a fonte do Discord (gg sans) e proprietaria,
// e esta e a substituta livre mais proxima. Local, e nao via Google Fonts, para
// o app nao depender de rede externa nem vazar acesso dos usuarios.
import '@fontsource-variable/inter';
import './styles.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
